import { LitElement, html, css, t } from '@hh/global.js'
class HHProductRecs extends LitElement {
  static properties = {
    productId: { type: String, attribute: 'product-id' },
    sectionId: { type: String, attribute: 'section-id' },
    productRecs: { type: String, state: true },
    productsComp: { type: String, state: true },
  }

  connectedCallback() {
    super.connectedCallback()
    this.fetchData()
  }

  async fetchData() {
    this.productRecs = await fetch(
      `${
        window.Shopify.country == 'AE' ||
        window.Shopify.country == 'SA' ||
        window.Shopify.country == 'QA' ||
        window.Shopify.country == 'FR' ||
        window.Shopify.country == 'MX' ||
        window.Shopify.country == 'ES' ||
        window.Shopify.country == 'BR' ||
        window.Shopify.country == 'CN'
          ? window.routes.root_url
          : ''
      }/recommendations/products?limit=4&product_id=${
        this.productId
      }&section_id=${this.sectionId}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector(
          `.js-product-recommendations[data-type='recommended']`
        )

        if (recommendations?.innerHTML.trim().length) {
          return recommendations.innerHTML
        }
      })
      .catch((e) => {
        console.error(e)
      })

    this.productsComp = await fetch(
      `${
        window.Shopify.country == 'AE' ||
        window.Shopify.country == 'SA' ||
        window.Shopify.country == 'QA' ||
        window.Shopify.country == 'FR' ||
        window.Shopify.country == 'MX' ||
        window.Shopify.country == 'ES' ||
        window.Shopify.country == 'BR' ||
        window.Shopify.country == 'CN'
          ? window.routes.root_url
          : ''
      }/recommendations/products?limit=4&intent=complementary&product_id=${
        this.productId
      }&section_id=${this.sectionId}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector(
          `.js-product-recommendations[data-type='complementary']`
        )

        if (recommendations?.innerHTML.trim().length > 0) {
          return recommendations.innerHTML
        } else {
          return null
        }
      })
      .catch((e) => {
        console.error(e)
      })

    if (this.productRecs) {
      document.querySelector(
        '.js-product-recommendations[data-type="recommended"]'
      ).innerHTML = this.productRecs
    }

    if (this.productRecs) {
      document.querySelector(
        '.js-product-recommendations[data-type="complementary"]'
      ).innerHTML = this.productsComp
    }

    if (
      this.productRecs &&
      this.productsComp &&
      this.shadowRoot &&
      this.shadowRoot.querySelector('hh-tabs')
    ) {
      this.shadowRoot.querySelector('hh-tabs').requestUpdate()
    }

    document
      .querySelectorAll('[data-featured-link]')
      .forEach((nonAnchorLink) => {
        nonAnchorLink.addEventListener('click', () => {
          const link = nonAnchorLink.getAttribute('data-featured-link')
          window.location.href = link
        })
      })

    // Add keyboard navigation for tabs after render
    this.setupTabNavigation()
  }

  setupTabNavigation() {
    // Wait for next frame to ensure shadow DOM is updated
    requestAnimationFrame(() => {
      const tabs = this.shadowRoot?.querySelectorAll('.js-tab')
      if (!tabs || tabs.length === 0) return

      tabs.forEach((tab, index) => {
        tab.addEventListener('keydown', (e) => {
          let newIndex = index

          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault()
            newIndex = (index + 1) % tabs.length
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault()
            newIndex = (index - 1 + tabs.length) % tabs.length
          } else if (e.key === 'Home') {
            e.preventDefault()
            newIndex = 0
          } else if (e.key === 'End') {
            e.preventDefault()
            newIndex = tabs.length - 1
          } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            this.activateTab(tabs, index)
            return
          } else {
            return
          }

          // Activate the new tab
          this.activateTab(tabs, newIndex)
        })

        tab.addEventListener('click', () => {
          this.activateTab(tabs, index)
        })
      })
    })
  }

  activateTab(tabs, newIndex) {
    // Update all tabs
    tabs.forEach((t, i) => {
      const isSelected = i === newIndex
      t.setAttribute('aria-selected', isSelected.toString())
      t.classList.toggle('active', isSelected)

      // Update associated panel
      const panelId = t.getAttribute('aria-controls')
      const panel = this.shadowRoot?.querySelector(`#${panelId}`)
      if (panel) {
        panel.classList.toggle('hidden', !isSelected)
      }
    })

    // Focus the newly selected tab
    tabs[newIndex].focus()
  }

  render() {
    const landmarkId = `rec-landmark-${this.sectionId}`
    const ymalHeadingId = `ymal-heading-${this.sectionId}`
    const compHeadingId = `comp-heading-${this.sectionId}`

    return html`
      ${this.productRecs && this.productsComp
        ? html` <hh-tabs>
            <div
              class="rec-products container"
              role="region"
              aria-labelledby="${landmarkId}"
            >
              <h2 class="visually-hidden" id="${landmarkId}">
                ${t('products.product.recommendations_heading')}
              </h2>
              <div
                class="js-tablist"
                role="tablist"
                aria-label="${t('products.product.recommendations_heading')}"
              >
                <button
                  id="ymal-tab"
                  type="button"
                  class="rec-product__tab-button utility-2 js-tab active"
                  role="tab"
                  tabindex="0"
                  aria-selected="true"
                  aria-controls="ymal-panel"
                >
                  ${t('products.product.you_may_also_like')}
                </button>
                <button
                  id="comp-tab"
                  type="button"
                  class="rec-product__tab-button utility-2 js-tab"
                  role="tab"
                  tabindex="-1"
                  aria-selected="false"
                  aria-controls="comp-panel"
                >
                  ${t('products.product.styled_with')}
                </button>
              </div>

              <div class="flex rec-product__tab-content">
                <div
                  id="ymal-panel"
                  class="js-tabpanel"
                  role="tabpanel"
                  aria-labelledby="ymal-tab"
                  tabindex="-1"
                >
                  <slot name="product-recs"></slot>
                </div>
                <div
                  id="comp-panel"
                  class="js-tabpanel hidden"
                  role="tabpanel"
                  aria-labelledby="comp-tab"
                  tabindex="-1"
                >
                  <slot name="product-comps"></slot>
                </div>
              </div>
            </div>
          </hh-tabs>`
        : this.productRecs
          ? html`<div
              class="rec-products container"
              role="region"
              aria-labelledby="${ymalHeadingId}"
            >
              <h2 class="utility-2" id="${ymalHeadingId}">
                ${t('products.product.you_may_also_like')}
              </h2>
              <slot name="product-recs"></slot>
            </div>`
          : this.productsComp &&
            html`<div
              class="rec-products container"
              role="region"
              aria-labelledby="${compHeadingId}"
            >
              <h2 class="utility-2" id="${compHeadingId}">
                ${t('products.product.styled_with')}
              </h2>
              <slot name="product-comps"></slot>
            </div>`}
    `
  }

  static styles = [
    css`
      :host *,
      :host *::before,
      :host *::after {
        box-sizing: border-box;
      }
      .hidden {
        display: none;
      }

      .visually-hidden {
        position: absolute !important;
        overflow: hidden;
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        border: 0;
        clip: rect(0 0 0 0);
        word-wrap: normal !important;
      }
      .rec-products {
        align-items: center;
        display: flex;
        flex-direction: column;
        gap: var(--hh-space-sm);
        padding-top: var(--hh-space-xl);
        padding-bottom: var(--hh-space-xl);
      }

      .rec-product__list {
        display: grid;
        gap: var(--hh-page-gutter);
        grid-template-columns: 1fr 1fr;
      }

      @media screen and (min-width: 990px) {
        .rec-product__list {
          grid-template-columns: 1fr 1fr 1fr 1fr;
        }
      }

      .rec-product__tab-button.js-tab {
        background: transparent;
        border: none;
        border-bottom: 1px solid transparent;
        color: var(--hh-color-subdued);
        cursor: pointer;
        text-transform: capitalize;
        padding: 0 0 2px;
        margin: 0 6px;
      }

      .rec-product__tab-button.js-tab:focus-visible {
        outline: 2px solid var(--hh-color-focus, #000);
        outline-offset: 2px;
      }

      .rec-product__tab-content {
        width: 100%;
      }

      .rec-product__tab-button.active {
        color: var(--hh-color-ink);
        border-bottom: 1px solid var(--hh-color-ink);
      }

      .utility-2 {
        font: var(--hh-utility-2);
        letter-spacing: var(--hh-utility-2-letter-spacing);
        margin: 0;
        text-transform: var(--hh-utility-text-transform);
      }

      .container {
        width: 100%;
        max-width: 144rem;
        margin: 0 auto;
        box-sizing: border-box;
        padding-left: var(--hh-space-page-margins);
        padding-right: var(--hh-space-page-margins);
      }
    `,
  ]
}

customElements.define('hh-product-recs', HHProductRecs)
